import AiChatbotPage from "@components/new-ui/AiChatbot/AiChatbotPage";
import NewLayout from "@components/new-ui/Layout";
import React from "react";

const AiPage: React.FC = () => {
    return (
        <NewLayout
            title="WhatsApp AI Chatbot — Intelligent Automation for Business | Gallabox"
            description="Go beyond scripted bots. Gallabox AI chatbot understands intent, handles complex queries & learns from conversations. See a live demo →"
            canonical="https://gallabox.com/whatsapp-ai-chatbot"
            ogAttributes={{ image: "https://assets.gallabox.com/gb-home/ai/ai-og-revised.png" }}
        >
            <AiChatbotPage />
        </NewLayout>
    );
};

export default AiPage;
